import React, { Component } from "react";
import { connect } from "react-redux";
import ReactTooltip from "react-tooltip";
import StringUtils from "../../utils/string";

// SASS Imports
require("./TimeEntry.scss");

const LINK_MAX_LENGTH = 10;
const SUMMARY_MAX_LENGTH = 400;

class TimeEntry extends Component {
  _renderCommentHint() {
    const entry = this.props.entry;

    if (entry.comment) {
      if (entry.comment.length <= LINK_MAX_LENGTH) {
        return entry.comment;
      }

      const tipText = StringUtils.truncate(
        entry.comment,
        SUMMARY_MAX_LENGTH
      );
      const tipLink = StringUtils.truncate(
        entry.comment,
        LINK_MAX_LENGTH
      );

      return (
        <span>
          <a data-tip={tipText}>{tipLink}</a>
          <ReactTooltip
            type="info"
            place="right"
            className="tip-display"
            multiline={true}
          />
        </span>
      );
    }

    return "";
  }

  render() {
    const entry = this.props.entry;
    const isEmpty = Boolean(entry.noEntries);
    const isEditing = entry.id === this.props.editingEntry.id;
    const isCloning = entry.id === this.props.editingEntry._clonedFrom;
    const isCreating = isEmpty
      && (entry.entryDate === this.props.editingEntry.entryDate);
    const isSubmitted = entry.submitDate || false;
    let accountName = (!isEmpty && entry.account.accountName)
      ? entry.account.accountName
      : "";

    let metaInfo = (entry.category) ? [entry.category] : [];

    if (!isEmpty) {
      if (entry.location.city) {
        const city = entry.location.city.toString();
        const region = entry.location.region.toString();

        metaInfo.push(`${city.toLowerCase()}, ${region.toLowerCase()}`);

        if (entry.onsite) {
          metaInfo.push("On site");
        }
      }

      if (entry.serviceRequest && entry.serviceRequest.srNumber) {
        metaInfo.push(`SR #${entry.serviceRequest.srNumber}`);
      }

      const productLine = entry.productLine;
      if (productLine && productLine.productLineDescr) {
        metaInfo.push(
          productLine.productLineDescr.toString()
          .toLowerCase()
        );
      }

      if (entry.hasOwnProperty("opportunityId") && entry.opportunityId.length > 0) {
        metaInfo.push(entry.opportunityId)
      }
    }

    let actions = ["Create"];
    const highlightClass = {};

    if (!isEmpty) {
      if (!isSubmitted) {
        actions = ["Edit", "Clone", "Delete", "Submit"];
      } else {
        actions = ["Edit", "Clone"];
      }

      if (isCloning) {
        highlightClass.Clone = "highlight";
      } else if (isEditing) {
        highlightClass.Edit = "highlight";
      }
    } else {
      if (isCreating) {
        highlightClass.Create = "highlight";
      }
    }

    let actionButtons = actions.map((action, i) => {
      const pressHandler = () => {
        const handler = `on${action}`;
        this.props[handler](entry, this.props.workDay);
      };
      const className = "history-edit-links "
        + (highlightClass[action] || "");

      return (
        <span key={i}>
          <em>
            <a className={className} onClick={pressHandler}>
              {action}
            </a>
            {(actions.length > i + 1) && <span>&nbsp;&nbsp;|&nbsp;&nbsp;</span>}
          </em>
        </span>
      );
    });

    let description = (<div><em>No Entry</em></div>);
    let metaInfoDisplay = (<p>&nbsp;</p>);

    if (!isEmpty) {
      description = (
        <label>
          {(isSubmitted)
            ? (<img
              className="status-indicator"
              src={require("./assets/check.png")}
              alt="Submitted!"
            />)
            : (<input
              className="status-indicator"
              type="checkbox"
              checked={this.props.selected}
              onClick={(event) => {
                return this.props.setSubmitGroupEnabled(
                  entry,
                  event.target.checked
                );
              }}
            />)
          }
          <strong>{accountName}</strong>
        </label>
      );

      metaInfoDisplay = (
        <div className="metaInfoFormat">
          {metaInfo.join("\xa0|\xa0")}
          {"\xa0|\xa0"}
          {this._renderCommentHint()}
        </div>
      );
    }

    return (
      <div className="entry">
        <div className="col-xs-10">
          {description}
          {metaInfoDisplay}
          {actionButtons}
        </div>
        <div className="col-xs-2 text-center no-padding">
          <h2>{entry.hours.toFixed(1)}</h2>
          <h6>HOURS</h6>
        </div>
      </div>
    );
  }
}

export default TimeEntry;



// WEBPACK FOOTER //
// ./app/components/History/TimeEntry.jsx